import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

/**
 * Icono de países/bandera para BordOneToneIcon
 */
const BordCountriesIcon = (props: ComponentProps<'svg'>) => {
  const { stroke, fill } = props;
  const defaultStroke = stroke || bordColorTheme.navyBlue[400];
  const defaultFill = fill || bordColorTheme.white[50];
  
  return (
    <svg viewBox="0 0 18 18" fill="none">
      <path
        className="flag"
        d="M3.414 7.663c.17 1.084 1.404 1.945 2.93 1.998 1.055.036 2.132.055 3.301.055 1.17 0 2.247-.019 3.302-.055 1.526-.053 2.76-.914 2.93-1.998.115-.73.209-1.478.209-2.24 0-.763-.094-1.512-.209-2.242-.17-1.084-1.404-1.945-2.93-1.997a95.137 95.137 0 0 0-3.302-.055c-1.169 0-2.246.019-3.301.055-1.526.052-2.76.913-2.93 1.997-.115.73-.209 1.479-.209 2.241 0 .763.094 1.511.209 2.241Z"
        fill={defaultFill}
        stroke={defaultStroke}
      />
      <path
        className="mast"
        d="M3.205 1.129v15.743"
        stroke={defaultStroke}
        strokeLinecap="round"
      />
      <path
        className="dot"
        d="M9.647 6.707a1.286 1.286 0 1 0 0-2.571 1.286 1.286 0 0 0 0 2.571Z"
        fill={defaultStroke}
      />
    </svg>
  );
};

export default BordCountriesIcon;
